<template>
  <div class="content-center none-click">
    <div class="banner">
      <img src="@/assets/Mobile/images/solution/member_banner.png" alt="">
    </div>
    <div class="block01">
      <div class="sk-mobile-title">
        <div class="title">您是否遇到这些问题？</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/Mobile/images/solution/member01.png" alt="">
          <span>获客难度大、成本高</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/member02.png" alt="">
          <span>客户资料零散，统一管理艰难</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/member03.png" alt="">
          <span>纸质化办公，数据 资料无法长久留存</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/member04.png" alt="">
          <span>团队内部工作流程规范度低，工作效率低下</span>
        </div>
      </div>
    </div>
    <div class="block02">
      <img src="@/assets/Mobile/images/solution/member05.png" alt="">
    </div>
    <div class="block03">
      <div class="sk-mobile-title">
        <div class="title">会员crm全生命周期管理解决方案</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/Mobile/images/solution/member06.png" alt="">
          <span class="title">全渠道引流获客</span>
          <span class="title">沉淀私域资产</span>
          <span class="colorBlock" />
          <span class="text">
            深入全渠道获客场景，通过二维活码覆盖线上/线下获客渠道，激活客户触点
          </span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/member07.png" alt="">
          <span class="title">客户360°视图</span>
          <span class="title">促进客户服务与价值提升</span>
          <span class="colorBlock" />
          <span class="text">
            客户基础信息、跟进记录、商机信息等全面记录永久保存，将碎片化客户信息沉淀为客户数据资产
          </span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/member08.png" alt="">
          <span class="title">精细运营赋能</span>
          <span class="title">激活客户复购转化</span>
          <span class="colorBlock" />
          <span class="text">
            圈选目标客户标签，通过个性化内容营销，挖掘客户深度需求，打造个性化客户旅程，促进转化
          </span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/member09.png" alt="">
          <span class="title">自动化运营</span>
          <span class="title">提升客户价值</span>
          <span class="colorBlock" />
          <span class="text">针对不同生命周期阶段的客户，灵活配置针对性的运营流程，自由组合运营工具
          </span>
        </div>
      </div>
    </div>
    <div class="block04">
      <div class="sk-mobile-title">
        <div class="title">聚焦核心场景深入</div>
      </div>
      <div class="content">
        <div class="title">线上拉新预与转化</div>
        <div class="line" />
        <div class="cont-item cont-item-first">
          <div class="sub-title">多渠道为店铺做定向推荐拉新，触达更多新用户</div>
          <div class="item-block">
            <div class="list-item"><div class="circle" /><span class="tit">流量坑位资源监控及预测，在排名靠前的流量坑位中进行露出</span></div>
            <img src="@/assets/Mobile/images/solution/member10.png" alt="">
          </div>
        </div>
        <div class="cont-item cont-item-second">
          <div class="sub-title">同一领域商品关联推荐，并叠加促销，提高客单价，提高库存周转效率，提升店铺的利润增长</div>
          <div class="item-block">
            <div class="list-item"><div class="circle" /><span class="tit">关联/搭配品推荐</span></div>
            <div class="list-item"><div class="circle" /><span class="tit">虚实商品结合</span></div>
            <img src="@/assets/Mobile/images/solution/member11.png" alt="">
          </div>
        </div>
        <div class="cont-item cont-item-third">
          <div class="sub-title">对已流失或者在流失边缘的店铺粉丝进行召回，唤醒沉睡用户，挖掘更多用户价值</div>
          <div class="item-block">
            <div class="list-item"><div class="circle" /><span class="tit">自动为店铺创建唤醒活动，通过短信形式将活动链接传达给用户群体</span></div>
            <img src="@/assets/Mobile/images/solution/member12.png" alt="">
          </div>
        </div>
      </div>
      <div class="content">
        <div class="title">导流线下与裂变</div>
        <div class="line" />
        <div class="cont-item cont-item-first">
          <div class="sub-title">利用内外部媒体产品矩阵，直播、短视频等，线上流量引导至线下，增加用户和店铺的互动频率</div>
          <div class="item-block">
            <div class="list-item"><div class="circle" /><span class="tit">用户获得线上优惠券，到店消费即可享受折扣优惠</span></div>
            <img src="@/assets/Mobile/images/solution/member13.png" alt="" style="width:251px;height:212px;">
          </div>
        </div>
        <div class="cont-item cont-item-second">
          <div class="sub-title">设置平台会员日固定促活运营活动，签到+分享+汇金币，支持引流到门店兑换</div>
          <div class="item-block">
            <div class="list-item"><div class="circle" /><span class="tit">平台会员日固定时间点签到并成功提醒N个粉丝签到成功，可获得大额汇金币，支持兑换话费或实物礼品</span></div>
            <img src="@/assets/Mobile/images/solution/member14.png" alt="" style="width:330px;height:188px;">
          </div>
        </div>
        <div class="cont-item cont-item-third">
          <div class="sub-title">在外部媒体产品中投放推广广告，将线上流量引导具体门店</div>
          <div class="item-block">
            <div class="list-item"><div class="circle" /><span class="tit">购买广告推广套餐，可将店铺活动等信息在外部的产品终端进行定向推广
            </span></div>
            <img src="@/assets/Mobile/images/solution/member15.png" alt="" style="width:249px;height:249px;">
          </div>
        </div>
      </div>
    </div>
    <IndustrySolution />
    <Case title="会员CRM" />
    <ContactForm info-sources="会员CRM" />
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import ContactForm from '@/Mobile/Mobilecom/ContactForm'
import IndustrySolution from '@/Mobile/Mobilecom/IndustrySolution'
import Case from '@/Mobile/Mobilecom/Case'

export default {
  metaInfo: metaInfo.Member,
  components: {
    ContactForm,
    IndustrySolution,
    Case
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  height: 200px;
  margin-top: 50px;
  img {
    width: 100%;
  }
}
.block01 {
  height: 187px;
  background-color: #F8F8FD;
  padding-bottom: 23px;
  .content {
    display: flex;
    justify-content: space-between;
    width: 340px;
    margin: 19px auto;
    .item {
      margin-top: 7px;
      display: flex;
      flex-direction: column;
      align-items: center;
      span {
        display: inline-block;
        margin-top: 15px;
        width: 64px;
        height: 22px;
        font-size: 8px;
        font-weight: 500;
        color: #595961;
        line-height: 11px;
      }
      img {
        width: 58px;
      }
    }
  }
}

.block02 {
  background-color: #fafafa;
  padding: 31px 19px 24px 17px;
  img {
    width: 314px;
    // margin: 13px 0 17px 0;
  }
}

.block03 {
  padding: 0px 16px 24px;
  background: #F8F8FD;
  .content {
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    margin-top: 22px;
    .item {
      display: flex;
      flex-direction: column;
      font-size: 12px;
      line-height: 22px;
      width: 162px;
      height: 153px;
      margin-bottom: 31px;
      justify-content: center;
      align-items: center;
      .title {
        display: inline-block;
        font-size: 12px;
        font-weight: 500;
        line-height: 20px;
      }
      img {
        width: 55px;
        height: 55px;
        margin-bottom: 14px;
      }
      img:first-child {
        width: 53px;
        height: 47px;
      }
      img:nth-child(2) {
        width: 50px;
        height: 50px;
      }
      img:nth-child(3) {
        width: 55px;
        height: 52px;
      }
      img:nth-child(4) {
        width: 52px;
        height: 55px;
      }
      .colorBlock {
        width: 24px;
        height: 4px;
        background: purple;
        margin: 10px auto 8px;
      }
      .text {
        display: inline-block;
        width: 126px;
        height: 53px;
        font-size: 8px;
        font-weight: 400;
        color: #8B8FA1;
        line-height: 14px;
      }
    }
  }
}

.block04 {
  .content {
    padding: 20px 16px 14px;
    .title {
      font-size: 18px;
      font-weight: 600;
      color: #595961;
      line-height: 29px;
      text-align: left;
    }
    .line {
      width: 13px;
      height: 2px;
      background: #6038EA;
      margin: 16px 0 15px;
    }
    .sub-title {
      font-size: 15px;
      font-weight: 500;
      color: #595961;
      line-height: 24px;
      padding-left: 30px;
      margin-bottom: 17px;
      text-align: left;
    }
    .cont-item-first {
      .sub-title {
        background: url("~@/assets/Mobile/images/solution/member_no01.png") no-repeat left 2px;
        background-size: 27px 16px;
      }
    }
    .cont-item-second{
      .sub-title {
        background: url("~@/assets/Mobile/images/solution/member_no02.png") no-repeat left 2px;
        background-size: 27px 16px;
      }
    }
    .cont-item-third {
      .sub-title {
        background: url("~@/assets/Mobile/images/solution/member_no03.png") no-repeat left 2px;
        background-size: 27px 16px;
      }
    }
    .item-block {
      .list-item {
        display: flex;
        margin-left: 5px;
        .circle {
          width: 6px;
          height: 6px;
          // line-height: 20px;
          border-radius: 3px;
          background: #6038EA;
          margin: 6px 5px 0;
        }
        .tit {
          font-size: 11px;
          font-weight: 400;
          color: #595961;
          line-height: 20px;
          text-align: left;
        }
      }
      img {
        display: block;
        width: 213px;
        height: 198px;
        margin: 17px auto 31px;
      }
    }
  }
}
</style>
